module.exports = __webpack_public_path__ + "static/media/profile.01e21540.png";